import usegetdata from '../../Hooks/useGetData';
import { useinsertdatawithoutimage } from '../../Hooks/usePostData';
import { UpdateProductdata } from '../../Hooks/useUpdateData';
import usedeletedata from '../../Hooks/useDeleteData';
import {
  Add_Commission_Pay_Type,
  Delete_Payment_Type,
  Get_Developer_Statement_Type,
  Get_Error,
  GetAll_Payments_For_Commission_Pay_Type,
  Update_Payment_Type,
} from '../Types';

// Add Commission Data
export const Add_Commission_Pay_Data_Action = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`/api/v1/CommissionPays`, body);

    dispatch({
      type: Add_Commission_Pay_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// get All  Commission Pays Data
export const Get_All_Pays_For_Commission_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/CommissionPays?Commission=${id}`);

    dispatch({
      type: GetAll_Payments_For_Commission_Pay_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Delete selected payment   Data
export const Delete_Selected_Payment_For_Commission_Data_Action = (id) => async (dispatch) => {
  try {
    const res = await usedeletedata(`/api/v1/CommissionPays/${id}`);

    dispatch({
      type: Delete_Payment_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Update selected payment   Data
export const UpdatePaymentAction = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/CommissionPays/${id}`, body);

    dispatch({
      type: Update_Payment_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};

// Update selected payment   Data
export const Get_Developer_Statement_Action = (developerid) => async (dispatch) => {
  try {
    const res = await usegetdata(
      `/api/v1/CommissionPays/developer-statement?developerId=${developerid}`,
    );

    dispatch({
      type: Get_Developer_Statement_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};
